import * as React from 'react';

import ArrowBackward from '../../assets/svg-components/arrow_back_thick.svg';
import ArrowForward from '../../assets/svg-components/arrow_forward_thick.svg';
import { Text } from '../text/text';
import './presentational-link.scss';

export interface PresentationalLinkProps {
  onClick: any;
  direction: 'forward' | 'backward';
}

const PresentationalLink: React.FC<PresentationalLinkProps> = ({ children, direction, onClick }) => {
  return (
    <div onClick={onClick}>
      <span className="sg-presentational-link">
        {direction === 'forward' && <ArrowBackward className="sg-presentational-link-icon" />}
        <Text
          className="sg-presentational-link-text"
          size="medium"
          color="default"
          tag="span"
          weight="bold"
          transform="uppercase"
        >
          {children}
        </Text>
        {direction === 'backward' && <ArrowForward className="sg-presentational-link-icon" />}
      </span>
    </div>
  );
};
export default PresentationalLink;
